import React from 'react';
import DateField from '../../../../Components/Form/components/DateField';
import FormMultiplier from '../../../../Components/Form/FormMultiplier';
import TimePickerField from '../../../../Components/Form/components/TimePickerField/TimePickerField';
import FormContainer from '../../../../Components/Form/FormContainer';
import styles from './CSSZSickLeaveCertificateOutingsFields.module.scss';
import FormMultiplierRemoveButton from '../../../../Components/Form/FormMultiplierRemoveButton';
import RemoveIconButton from '../../../../Components/Button/RemoveIconButton';

interface Props {
	containerName: string;
}

const CSSZSickLeaveCertificateOutingsFields: React.FC<Props> = ({
	containerName,
}) => {
	return (
		<FormContainer name={containerName} className={styles.permittedWalks}>
			<div className={styles.dateCol}>
				<DateField
					name='outingsStartDate'
					label='component.CSSZSickLeaveCertificateFormPartE.outingsStartDate'
				/>
			</div>
			<div className={styles.intervalsCol}>
				<FormMultiplier
					name='outingIntervals'
					createDefault={1}
					allowAddForm={true}
					className={styles.inlineMultiplier}>
					<div className={styles.intervalRow}>
						<div className={styles.inline}>
							<TimePickerField
								name='timeFrom'
								label='component.CSSZSickLeaveCertificateFormPartE.timeFrom'
								className={styles.timePicker}
							/>
							<TimePickerField
								name='timeTo'
								label='component.CSSZSickLeaveCertificateFormPartE.timeTo'
								className={styles.timePicker}
							/>
						</div>
						<div className={styles.buttonContainer}>
							<FormMultiplierRemoveButton>
								<RemoveIconButton />
							</FormMultiplierRemoveButton>
						</div>
					</div>
				</FormMultiplier>
			</div>
		</FormContainer>
	);
};

export default CSSZSickLeaveCertificateOutingsFields;
